import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";
import { Link, useNavigate } from "react-router-dom";

const CategoriesDetails = () => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]); // State for filtered categories
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [isScrolled, setIsScrolled] = useState(false);
  const [BreadcrumList, setBreadcrumList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch("Rental/GetRentalCategoryDetails");
        if (response && response.length > 0) {
          const mappedCategories = response.map((category) => ({
            ...category,
            image: category.imagePath
              ? `${ImageURL}${category.imagePath}`
              : null,
          }));
          setCategories(mappedCategories);
          setFilteredCategories(mappedCategories); // Keep filtered categories consistent
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchBreadcrumImageData = async () => {
      try {
        const response = await corefetch(
          "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=RDETAILS"
        );
        if (response && response.length > 0) {
          console.log("fxftyxfyt:", response);
          setBreadcrumList(response);
        } else {
          setBreadcrumList([]);
          console.log("No Breadcrum found");
        }
      } catch (error) {
        console.error("Error fetching Breadcrum List:", error);
        setBreadcrumList([]);
      }
    };

    fetchData();
    fetchBreadcrumImageData();
  }, []);

  const backgroundImageStyle = BreadcrumList[0]
        ? {
            backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }
        : {};

  // Search filter function
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = categories.filter((category) =>
      category.categoryName.toLowerCase().includes(query)
    );
    setFilteredCategories(filtered);
  };

  useEffect(() => {
    const $ = window.jQuery;
    const navbar = $(".navbar");
    const logo = $(".navbar .logo> img");
    const paymentIcon = $(".payment");
    const cartIcon = $(".cart");
    navbar.addClass("shared-banner-style");
    logo.attr("src", "/assets/images/corporate-img/img/logo/meridian.png");

    if (navbar.hasClass("shared-banner-style")) {
      $(".navbar .navbar-nav .nav-link").css("color", "#000");
      $(".dropdown .nav-link i").css("color", "black");
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    }

    // Scroll Event Listener (only modifies UI, does not reset data)
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener("popstate", handlePopState);
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <>
      <div className="wpo-page-title " style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div
                className="wpo-breadcumb-wrap"
                style={{ textAlign: "center" }}
              >
                <h2 style={{ color: "white" }}>Categories</h2>
                <ol
                  className="wpo-breadcumb-wrap"
                  style={{
                    color: "white",
                    display: "inline-block",
                    padding: 0,
                  }}
                >
                  <li>
                    <a
                      href="/home"
                      style={{
                        cursor: "pointer",
                        color: "white",
                        textDecoration: "none", 
                      }}
                    >
                      Home
                    </a>
                  </li>

                  <span style={{ color: "white", margin: "0 5px" }}>|</span>
                  <li
                    style={{
                      color: "white",
                     
                    }}
                  >
                    Categories
                  </li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </div>
      {/* Search Input */}
      <div className="floating-search">
        <i className="flaticon-search"></i>
        <input
          type="text"
          placeholder="Search categories..."
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>

      {/* Categories List */}
      <section className="rooms1 section-padding pb-60" data-scroll-index={1}>
        <div className="container">
          <div className="row">
            {filteredCategories.length > 0 ? (
              filteredCategories.map((category) => (
                <div className="col-md-6 mb-60" key={category.categoryID}>
                  <div className="rooms1-single">
                    <div className="rooms1-img">
                      <img
                        className="shop-image"
                        src={category.image}
                        alt={category.categoryName}
                      />
                    </div>
                    <div className="rooms1-content active">
                      <div className="row">
                        <div className="col-8 text-start rooms1-title-Dum">
                          <a>{category.categoryName}</a>
                        </div>
                        <div className="col-4 text-end">
                          <a
                            href={`/rentalitem/${category.categoryID}`}
                            className="butn-dark2"
                          >
                            <span>Explore</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center mt-4">
                <h4>Category Not available</h4>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default CategoriesDetails;
